import type { BenchmarkClienteFazendas, BenchmarkLocalUserStatus } from "services/BenchmarkService";
import type { BenchmarkDispatchAction } from "redux/actions/benchmarkActions";

type BenchmarkEditUserState = {
  localUserStatus: BenchmarkLocalUserStatus | null;
  hasUserAccess: boolean;
  associacoes: BenchmarkClienteFazendas[];
  carregando: boolean;
};

export type BenchmarkState = {
  loggedUserHasAccess: boolean;
  loggedUserHasContextualAccess: boolean;
  userAccess: { [email: string]: boolean };
  farmAccess: { [farmId: number]: boolean };
  editUser: BenchmarkEditUserState;
};

const editUserInitialState: BenchmarkEditUserState = {
  localUserStatus: null,
  hasUserAccess: false,
  associacoes: [],
  carregando: false,
};

export const initialState: BenchmarkState = {
  loggedUserHasAccess: false,
  loggedUserHasContextualAccess: false,
  userAccess: {},
  farmAccess: {},
  editUser: editUserInitialState,
};

export default function benchmarkReducer(
  state: BenchmarkState = initialState,
  action: BenchmarkDispatchAction,
): BenchmarkState {
  switch (action.type) {
    case "FETCH_BENCHMARK_ACCESS_DETAILS_FOR_LOGGED_USER":
      return {
        ...state,
        loggedUserHasAccess: action.payload.hasAccess,
        loggedUserHasContextualAccess: action.payload.hasContextualAccess,
      };
    case "FETCH_BENCHMARK_ACCESS_FOR_TARGET_USER":
      return {
        ...state,
        userAccess: {
          ...state.userAccess,
          [action.payload.targetUserEmail]: action.payload.hasAccess,
        },
      };
    case "FETCH_BENCHMARK_ACCESS_FOR_FARM":
      return {
        ...state,
        farmAccess: {
          ...state.farmAccess,
          [action.payload.farmId]: action.payload.hasAccess,
        },
      };
    case "SET_BENCHMARK_EDIT_USER_STATUS":
      return {
        ...state,
        editUser: {
          ...state.editUser,
          localUserStatus: action.payload.localUserStatus,
          hasUserAccess: action.payload.hasUserAccess,
        },
      };
    case "SET_BENCHMARK_EDIT_USER_ASSOCIACOES":
      return {
        ...state,
        editUser: {
          ...state.editUser,
          associacoes: action.payload.associacoes,
          carregando: false,
        },
      };
    case "SET_BENCHMARK_EDIT_USER_CARREGANDO":
      return {
        ...state,
        editUser: {
          ...state.editUser,
          carregando: action.payload.carregando,
        },
      };
    case "RESET_BENCHMARK_EDIT_USER":
      return { ...state, editUser: editUserInitialState };
    default:
      return state;
  }
}
